// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Maldives */
const MV = /^(?:(?:46[46]|[79]\d\d)\d{4})$/;

export default MV;
